<style scoped lang="scss">
.dialog-day-table {
    /deep/ .el-table__body-wrapper {
        min-height: 560px;
    }
}
/deep/ .page-daywork-dialog {
    margin-top: 5vh !important;
    width: 96%;
    height: auto;
}
</style>

<template>
  <div class="page-maintenance-dayworks">
    <div class="toolbars mrgb5">
        <div class="buttons mrgb5">
            <div class="fl">
              <el-button-group class="mrgr5 mrgb5">
                  <el-button :class="$root.isPc ? '' : 'mobile-group-button'" type="primary" v-for="(tab, index) in tabs" :plain="tabIndex !== index"
                      :key="'employee_tab_' + index" size="medium" @click="tabClick(index)">{{ tab }}</el-button>
              </el-button-group>
              <el-date-picker class="c-datetime-range mrgr5 mrgb5" v-model="selectedTime" type="datetimerange" size="medium" v-show="isShowSelectTime"
                    :picker-options="pickerOptions" :default-time="['00:00:00', '23:59:59']" @change="_search"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    align="right">
                </el-date-picker>
            </div>
            <div class="fr">
                <!-- <span class="mrgr5 mrgb5" v-if="isSystem || !isDetailQuery">
                    <el-tooltip content="全部员工数据：包含未配置归属服务区的数据" placement="top-start">
                        <el-checkbox v-model="listQuery.showNoAreaData" label="全部记录" border size="medium"
                            @change="showAllRecords()">
                        </el-checkbox>
                    </el-tooltip>
                </span> -->
                <span class="mrgr5 mrgb5">
                    <el-checkbox v-model="listQuery.isFilterArea" label="仅看当前服务区" border size="medium"
                        @change="serviceAreaChange"></el-checkbox>
                </span>
                <el-select class="c-el-input mrgr5 mrgb5" style="width: 120px;" placeholder="审核状态" size="medium" filterable
                    clearable v-model="listQuery.audited" @change="_search()">
                    <el-option label="已审核" :value="true"></el-option>
                    <el-option label="未审核" :value="false"></el-option>
                </el-select>
                <el-input class="c-el-input mrgr5 mrgb5" style="width: 165px;" placeholder="员工的姓名/手机号" clearable v-model="listQuery.keywords"
                    size="medium" v-if="!isDetailQuery"></el-input>
                <!--<el-date-picker class="c-datetime-range mrgr5 mrgb5" v-model="selectedTime" type="datetimerange" size="medium"
                    :picker-options="pickerOptions" :default-time="['00:00:00', '23:59:59']" @change="_search"
                    :disabled="isDetailQuery"
                    range-separator="至"
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    align="right">
                </el-date-picker>-->
                <el-button type="primary" size="medium" @click="_search()" v-if="!isDetailQuery"><i class="fa fa-search"></i> 查询</el-button>
                <el-button class="mrgb5" type="warning" size="medium" @click="openExportExcel()"><i class="fa fa-sign-out"></i> 导出</el-button>
                <el-tooltip content="将重新计算员工的工作时间、工作量统计等数据。" placement="top-start">
                    <el-button class="mrgb5" type="danger" size="medium" @click="_updateState()"><i class="el-icon-refresh"></i> 更新数据</el-button>
                </el-tooltip>
                <el-tooltip effect="dark" placement="bottom-end">
                    <div slot="content">
                        1、默认统计权限范围内所有服务区的员工记录数据。<br />
                        2、扫一扫默认不会统计到有效工作时间内，需要将员工身份配置为“巡检”才能计算在内。<br />
                        3、工作时间都是按00:00:00-23:59:59算一天的上班时间。<br />
                    </div>
                    <el-tag class="mrgl5" type="warning" size="medium"><i class="el-icon-view f12"></i> 查看说明</el-tag>
                </el-tooltip>
            </div>
            <div class="clearb"></div>
        </div>
    </div>
    <!-- :class="isDetailQuery ? 'dialog-day-table' : ''" -->
    <el-table class="dialog-day-table" :data="tableData"
        fit border size="medium" @row-dblclick="showWorkEchart" :show-summary="true">
        <!--<el-table-column label="ID" prop="id" min-width="120"></el-table-column>-->
        <el-table-column label="日期" prop="date" width="100"></el-table-column>
        <el-table-column label="名称" prop="name">
            <template slot-scope="scope">
                <span>{{ scope.row.name }}</span>
                <el-button class="mrgl10" type="text" @click="_config(scope.row)" v-if="isEmployeeWorkConfig">
                    <i class="el-icon-edit-outline col_warning"></i>
                </el-button>
            </template>
        </el-table-column>
        <el-table-column label="联系电话" prop="tel" width="160"></el-table-column>
        <el-table-column label="归属服务区" prop="serviceName" width="150"></el-table-column>
        <el-table-column label="员工身份">
            <template slot-scope="scope">
                <span>{{ scope.row.roleDesc || "" }}</span>
            </template>
        </el-table-column>
        <el-table-column label="工作时间(参考时长)" min-width="250">
            <template slot-scope="scope">
                <div v-for="item in scope.row.workTimePeriods" :key="item.name">
                    <span>{{ item.name }}：{{ item.startTime }}~{{ item.endTime }} ({{ item.durationTxt }})</span>
                </div>
            </template>
        </el-table-column>
        <!-- <el-table-column label="首次工作时间" prop="startTime"></el-table-column>
        <el-table-column label="最后工作时间" prop="endTime"></el-table-column> -->
        <el-table-column label="有效工作时间" prop="workHours" width="120">
            <template slot-scope="scope">
                <el-link @click="showWorkHours(scope.row)">{{ scope.row.workHours }}小时<i class="el-icon-view el-icon--right"></i> </el-link>
            </template>
        </el-table-column>
        <el-table-column label="总挪车量" prop="moveCount">
            <template slot-scope="scope">
                <el-tooltip effect="dark" placement="top-end" content="总挪车量">
                    <el-tag size="small" type="info" @click="showMoveData(scope.row)">{{ scope.row.moveCount }}</el-tag>
                </el-tooltip>
            </template>
        </el-table-column>
        <el-table-column label="有效挪车量" prop="effectiveMoveCount">
            <template slot-scope="scope">
                <el-tooltip effect="dark" placement="top-end" content="有效挪车量">
                    <span class="col_primary fwb" @click="showMoveData(scope.row, 1)">{{ scope.row.effectiveMoveCount }}</span>
                </el-tooltip>
            </template>
        </el-table-column>
        <el-table-column label="有效换电量" prop="batteryChangeCount">
            <template slot-scope="scope">
                <el-tooltip effect="dark" placement="top-end" content="有效换电量">
                    <span class="col_success fwb" @click="showBatteryData(scope.row, 1)">{{ scope.row.batteryChangeCount }}</span>
                </el-tooltip>
            </template>
        </el-table-column>
        <!-- <el-table-column label="巡检量" prop="inspectionCount"></el-table-column> -->
        <el-table-column label="有效维修量" prop="reparionCount">
            <template slot-scope="scope">
                <el-tooltip effect="dark" placement="top-end" content="有效维修量">
                    <span class="col_danger fwb" @click="showRepairData(scope.row, 1)">{{ scope.row.reparionCount }}</span>
                </el-tooltip>
            </template>
        </el-table-column>
        <el-table-column label="扫一扫" prop="scanCount">
            <template slot-scope="scope">
                <el-tooltip effect="dark" placement="top-end" content="扫一扫">
                    <span class="col_warning fwb">{{ scope.row.scanCount }}</span>
                </el-tooltip>
            </template>
        </el-table-column>
        <!-- <el-table-column label="工作状态" prop="statusDesc">
            <template slot-scope="scope">
                {{ tranceEmployeeDayWorkStatus(scope.row.status) }}
            </template>
        </el-table-column> -->
        <el-table-column label="绩效" prop="performance" fixed="right">
            <template slot-scope="scope">
                <el-tooltip :disabled="!scope.row.auditMessage" :content="'绩效备注：' + scope.row.auditMessage" placement="top-end">
                    <el-tag size="small" type="danger" effect="dark" v-if="!scope.row.audited">{{ scope.row.performance }}</el-tag>
                    <template v-else>
                        <el-tag size="small" type="info" v-if="scope.row.performance < 1">{{ scope.row.performance }}</el-tag>
                        <el-tag size="small" type="success" v-else-if="scope.row.performance > 1">{{ scope.row.performance }}</el-tag>
                        <el-tag size="small" v-else>{{ scope.row.performance }}</el-tag>
                    </template>
                </el-tooltip>
                <el-button class="mrgl10" type="text" icon="el-icon-edit" @click="_audit(scope.row)"></el-button>
            </template>
        </el-table-column>
        <el-table-column label="操作" prop="statusDesc" width="100" fixed="right">
            <template slot-scope="scope">
                <el-dropdown trigger="click">
                    <el-button type="primary" plain size="mini">更多<i class="el-icon-arrow-down el-icon--right"></i></el-button>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item @click.native="showWorkHours(scope.row)">工时核对</el-dropdown-item>
                        <el-dropdown-item @click.native="showMovingMap(scope.row)" v-if="isOperationMoveTask">挪车路线</el-dropdown-item>
                        <el-dropdown-item @click.native="showMoveData(scope.row)" v-if="isOperationMoveTask">挪车记录</el-dropdown-item>
                        <el-dropdown-item @click.native="showBatteryData(scope.row)" v-if="isOperationBatteryChangeTask">换电记录</el-dropdown-item>
                        <el-dropdown-item @click.native="showRepairData(scope.row)" v-if="isOperationMaintenanceLog">维修记录</el-dropdown-item>
                        <el-dropdown-item @click.native="showWorkEchart(scope.row)">统计图表</el-dropdown-item>
                        <el-dropdown-item @click.native="_audit(scope.row)">绩效审核</el-dropdown-item>
                        <el-dropdown-item @click.native="_config(scope.row)" v-if="isEmployeeWorkConfig">员工配置</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </template>
        </el-table-column>
    </el-table>

    <div class="pagination-container" v-if="isPagination">
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" 
            :current-page="listQuery.page" :page-sizes="appPageSizes" :page-size="listQuery.size" 
            layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
    </div>

    <!--导出excel-->
    <export-to-excel :ref="refExportToExcel"></export-to-excel>
    <!--审核-->
    <audit :ref="refAudit" @refreshData="getDataList()"></audit>
    <!--员工配置-->
    <config :ref="refConfig"></config>
    <!--工作统计-->
    <work-echart :ref="refWorkEchart"></work-echart>
    <!--工作时间段-->
    <work-hours :ref="refWorkHours"></work-hours>
    <!--员工挪车路线-->
    <member-moving-map :ref="refMemberMovingMap"></member-moving-map>
    <!--员工工作数据-->
    <el-dialog :title="dialogTitle" :fullscreen="true" :append-to-body="true"
        :visible.sync="showDialog" :before-close="_close" :close-on-click-modal="false">
        <!--员工挪车数据-->
        <member-move-data :ref="refMemberMoveData" v-if="showDialogType === 1"></member-move-data>
        <!--员工换电数据-->
        <member-battery-data :ref="refMemberBatteryData" v-if="showDialogType === 2"></member-battery-data>
        <!--员工维修数据-->
        <member-repair-data :ref="refMemberRepairData" v-if="showDialogType === 3"></member-repair-data>
    </el-dialog>
  </div>
</template>

<script>
  import permission from "@/mixins/permission"
  import enumConfigs from "@/mixins/enumConfigs"
  import * as funEmployees from '@/api/employees'
  import moment from "moment"
  import ExportToExcel from "@/components/Excels/JsonToExcel"
  import audit from "./components/performance"
  import config from "./components/editWork"
  import { EmployeeDayWorkLogs } from "@/mixins/commonPageExport"
  import WorkEchart from "./components/workEchart"
  import WorkHours from "./components/workHours"
  import MemberMovingMap from "@/views/admin/analysis/components/memberMovingMap"
  import MemberMoveData from "@/views/admin/employees/moveData"
  import MemberBatteryData from "@/views/admin/employees/batteryData"
  import MemberRepairData from "@/views/admin/employees/maintenanceData"
  export default {
    name: "pageMaintenanceDayWorks",
    mixins: [permission, enumConfigs],
    components: { ExportToExcel, audit, config, WorkEchart, WorkHours, MemberMovingMap, MemberMoveData, MemberBatteryData, MemberRepairData },
    data() {
      let that = this
      return {
        refExportToExcel: "refDayWorksToExportExcel",
        refAudit: "refDayWorksToAudit",
        refConfig: "refDayWorksToConfig",
        refWorkEchart: "refWorkEchart",
        refWorkHours: "refWorkHours",
        refMemberMovingMap: "refMemberMovingMap",
        refMemberMoveData: "refMemberMoveData",
        refMemberBatteryData: "refMemberBatteryData",
        refMemberRepairData: "refMemberRepairData",
        tableData: [],
        total: null,
        defaultQueryParams: {
            isFilterArea: false,
            showNoAreaData: true,
            area: "",
            audited: null,
            keywords: "",
            startDate: "",
            endDate: "",
            page: 1,
            size: 40
        },
        listQuery: {},
        isPagination: false,
        selectedTime: [moment().subtract(1, "d").format("YYYY-MM-DD 00:00:00"), moment().subtract(1, "d").format("YYYY-MM-DD 23:59:59")],
        pickerOptions: {
            shortcuts: [
                {
                    text: "昨天",
                    onClick: (picker) => {
                        let timeArr = that.setPickerTime(picker, 1, "days")
                        that.setQueryTime(timeArr)
                    }
                },
                {
                    text: "近一周",
                    onClick: (picker) => {
                        let timeArr = that.setPickerTime(picker, 1, "weeks")
                        that.setQueryTime(timeArr)
                    }
                },
                {
                    text: "近一月",
                    onClick(picker) {
                        let timeArr = that.setPickerTime(picker, 1, "months")
                        that.setQueryTime(timeArr)
                    }
                },
                {
                    text: "近三月",
                    onClick(picker) {
                        let timeArr = that.setPickerTime(picker, 3, "months")
                        that.setQueryTime(timeArr)
                    }
                },
                {
                    text: "近半年",
                    onClick(picker) {
                        let timeArr = that.setPickerTime(picker, 6, "months")
                        that.setQueryTime(timeArr)
                    }
                },
                {
                    text: "近一年",
                    onClick(picker) {
                        let timeArr = that.setPickerTime(picker, 1, "years")
                        that.setQueryTime(timeArr)
                    }
                }
            ]
        },
        selectDate: moment().subtract(1, "d").format("YYYY-MM-DD"),
        tabIndex: 0,
        tabs: ["昨日", "本月", "上月", "自定义"],
        isShowSelectTime: false,
        isDetailQuery: false,
        dialogTitle: "",
        showDialog: false,
        showDialogType: 0
      }
    },
    watch: {
        "$store.getters.serviceArea"(v) {
            this.mxIsSameActiveTabWithRoute(() => {
                this.serviceAreaChange(this.listQuery.isFilterArea)
            })
        }
    },
    /* activated() {
        this.isDetailQuery = false
        let params = this.$route.params
        if (params) {
            this.listQuery.isFilterArea = params.isFilterArea || false
            this.listQuery.keywords = params.keyword || ""
            if (params.selectedTime && params.selectedTime.length == 2) {
                this.selectedTime = params.selectedTime
            }
            this._search()
        } else {
            this._search()
        }
    }, */
    mounted() {
        this.open()
    },
    methods: {
        open(params) {
            // 重置查询参数
            this.listQuery = { ...this.defaultQueryParams }
            // 否则就是带参数查询，注意：不会有其他情况
            if (params) {
                this.isDetailQuery = true
                this.listQuery.isFilterArea = params.isFilterArea || false
                this.listQuery.platform = this.listQuery.isFilterArea ? this.$store.getters.servicePlatform : ""
                this.listQuery.area = this.listQuery.isFilterArea ? this.$store.getters.serviceArea : ""
                this.listQuery.keywords = params.keyword || ""
                if (params.selectedTime && params.selectedTime.length == 2) {
                    this.selectedTime = params.selectedTime
                }
                if (params.tabIndex !== undefined) {
                    this.tabClick(params.tabIndex, true)
                    if (params.tabIndex == 3) {
                        this._search()
                    }
                } else {
                    this.tabClick(0)
                }
            } else {
                this.isDetailQuery = false
                setTimeout(() => {
                    if (!this.isDetailQuery) {
                        this.tabClick(0)
                    }
                }, 500);
            }
        },
        // 重写本页的时间范围的快捷筛选，设置时间
        setPickerTime(picker, spaceTime, dateStr, isStartOf) {
            let timeArr = []
            let startTime = null
            let endTime = moment().subtract(1, "d").format("YYYY-MM-DD 23:59:59")
            startTime = moment().subtract(spaceTime, dateStr).format("YYYY-MM-DD 00:00:00")
            startTime = moment(startTime).format("YYYY-MM-DD 00:00:00")
            timeArr = [startTime, endTime]
            if (picker) {
                picker.$emit('pick', timeArr);
            }
            return timeArr
        },
        setQueryTime(timeArr) {
            this.listQuery.startDate = timeArr[0] || ""
            this.listQuery.endDate = timeArr[1] || ""
        },
        handleSizeChange(val) {
            window.$common.fullLoading()
            this.listQuery.size = val
            this.getDataList()
        },
        handleCurrentChange(val) {
            window.$common.fullLoading()
            this.listQuery.page = val
            this.getDataList()
        },
        setSelectDate() {
            if (this.selectDate && moment(this.selectDate).isValid()) {
                this.listQuery.startDate = moment(this.selectDate).format("YYYY-MM-DD 00:00:00")
                this.listQuery.endDate = moment(this.selectDate).format("YYYY-MM-DD 23:59:59")
            }
        },
        setSelectedTime() {
            let psTime = ""
            let peTime = ""
            if (this.selectedTime && this.selectedTime[0] && moment(this.selectedTime[0]).isValid()) {
                psTime = moment(this.selectedTime[0]).format("YYYY-MM-DD HH:mm:ss")
            }
            if (this.selectedTime && this.selectedTime[1] && moment(this.selectedTime[1]).isValid()) {
                peTime = moment(this.selectedTime[1]).format("YYYY-MM-DD HH:mm:ss")
            }
            this.listQuery.startDate = psTime
            this.listQuery.endDate = peTime
            this.selectedTime = [this.listQuery.startDate, this.listQuery.endDate]
        },
        getDataList () {
            this.setSelectedTime()
            window.$common.fullLoading()
            this.tableData = []
            this.listQuery.area = this.listQuery.isFilterArea ? this.$store.getters.serviceArea : ""
            this.listQuery.keywords = this.listQuery.keywords.trim()
            funEmployees.GetEmployeeDayWorks(this.listQuery).then(response => {
                window.$common.closeFullLoading()
                this.total = response.totalCount
                this.isPagination = response.totalCount > 0 || false
                if (response && response.items && response.items.length > 0) {
                    this.tableData = response.items.map(x => {
                        x.date = moment(x.date).format("YYYY-MM-DD")
                        x.roleDesc = this.arrEmployeeRole && this.arrEmployeeRole.find(y => y.value === x.role) ? this.arrEmployeeRole.find(y => y.value === x.role).desc : ""
                        /* if (x.startTime && x.endTime) {
                            let st = `${x.date} ${x.startTime}`
                            let et = `${x.date} ${x.endTime}`
                            x.durationDec = window.$util.converDuration(st, et, "h", true)
                            x.durationTxt = window.$util.converDuration(st, et, "h")
                            x.durationTxt = x.durationTxt || "0秒"
                        } */
                        // 计算时长
                        for (let t in x.workTimePeriods) {
                            let st = `${x.date} ${x.workTimePeriods[t].startTime}`
                            let et = `${x.date} ${x.workTimePeriods[t].endTime}`
                            x.workTimePeriods[t].durationDec = window.$util.converDuration(st, et, "h", true)
                            x.workTimePeriods[t].durationTxt = window.$util.converDuration(st, et, "h") || "0秒"
                        }
                        return x
                    })
                } else {
                    this.tableData = []
                }
            })
        },
        serviceAreaChange(val) {
            if (val === true) {
                this.listQuery.platform = this.$store.getters.servicePlatform || ""
                this.listQuery.area = this.$store.getters.serviceArea || ""
            } else if (val && typeof val === "object" && val.length > 1) {
                this.listQuery.platform = val[0] || ""
                this.listQuery.area = val[1] || ""
            } else {
                this.listQuery.platform = ""
                this.listQuery.area = ""
            }
            this._search()
        },
        tabClick(index, isKeepSelectTime) {
            this.tabIndex = index
            switch(index) {
                case 0: {
                    let endTime = moment().subtract(1, "d").format("YYYY-MM-DD 23:59:59")
                    this.selectedTime = [moment(endTime).format("YYYY-MM-DD 00:00:00"), endTime]
                    break
                }
                case 1: {
                    this.selectedTime = [moment().startOf("month").format("YYYY-MM-DD 00:00:00"), moment().format("YYYY-MM-DD 23:59:59")]
                    break
                }
                case 2: {
                    this.selectedTime = [moment().subtract(1, "month").startOf("month").format("YYYY-MM-DD 00:00:00"), moment().subtract(1, "month").endOf("month").format("YYYY-MM-DD 23:59:59")]
                    break
                }
            }
            if (index !== 3) {
                this.isShowSelectTime = false
                this._search()
            } else {
                if (!isKeepSelectTime) {
                    this.selectedTime = []
                }
                this.isShowSelectTime = true
                this.tableData = []
            }
        },
        showAllRecords() {
            this.listQuery.isFilterArea = false
            this._search()
        },
        _updateState() {
            this.setSelectedTime()
            let params = {
                area: this.listQuery.area,
                startDate: this.listQuery.startDate,
                endDate: this.listQuery.endDate,
                audited: this.listQuery.audited === "" || this.listQuery.audited === undefined ? null : this.listQuery.audited,
                telOrName: this.listQuery.keywords
            }
            if (!params.startDate || !params.endDate) {
                this.warningMsg("请选择更新时间段!")
                return false
            }
            window.$common.fullLoading()
            funEmployees.HandleDayWork(params).then(() => {
                this.getDataList()
                this.successMsg("工作状态更新成功!")
            })
        },
        tranceEmployeeDayWorkStatus(status) {
            let txt = ""
            let item = this.arrEmployeeDayWorkStatus && this.arrEmployeeDayWorkStatus.find(x => x.value === status)
            if (item) {
                txt = item.desc
            }
            return txt
        },
        showWorkEchart(row) {
            this.$refs[this.refWorkEchart].open(row) 
        },
        showWorkHours(row) {
            if (row && row.halfHourWorkDetails && row.halfHourWorkDetails.length > 0) {
                this.$refs[this.refWorkHours].open(row.halfHourWorkDetails)
                return false 
            }
            this.warningMsg("暂无数据!")
        },
        showMovingMap(row) {
            // 显示人员挪车路线
            this.$refs[this.refMemberMovingMap].open(row)
        },
        showMoveData(row, type) {
            if (!this.isOperationMoveTask) {
                this.warningMsg("暂无权限查看挪车记录")
                return false
            }
            // this.$refs[this.refMemberMoveData].open(row)
            this.dialogTitle = `【${row.name} | ${row.tel}】的挪车记录`
            this.showDialog = true
            this.showDialogType = 1
            setTimeout(() => {
                this.$refs[this.refMemberMoveData].open({
                    isFilterArea: this.listQuery.isFilterArea,
                    telOrName: row.name, 
                    selectedTime: [moment(row.date).format("YYYY-MM-DD 00:00:00"), moment(row.date).format("YYYY-MM-DD 23:59:59")],
                    type,
                    tabIndex: 3
                })
            }, 100)
        },
        showBatteryData(row, type) {
            if (!this.isOperationBatteryChangeTask) {
                this.warningMsg("暂无权限查看换电记录")
                return false
            }
            this.dialogTitle = `【${row.name} | ${row.tel}】的换电记录`
            this.showDialog = true
            this.showDialogType = 2
            setTimeout(() => {
                this.$refs[this.refMemberBatteryData].open({
                    isFilterArea: this.listQuery.isFilterArea,
                    telOrName: row.name, 
                    selectedTime: [moment(row.date).format("YYYY-MM-DD 00:00:00"), moment(row.date).format("YYYY-MM-DD 23:59:59")],
                    type,
                    tabIndex: 3
                })
            }, 100)
        },
        showRepairData(row, type) {
            if (!this.isOperationMaintenanceLog) {
                this.warningMsg("暂无权限查看维修记录")
                return false
            }
            this.dialogTitle = `【${row.name} | ${row.tel}】的维修记录`
            this.showDialog = true
            this.showDialogType = 3
            setTimeout(() => {
                this.$refs[this.refMemberRepairData].open({
                    isFilterArea: this.listQuery.isFilterArea,
                    telOrName: row.name, 
                    selectedTime: [moment(row.date).format("YYYY-MM-DD 00:00:00"), moment(row.date).format("YYYY-MM-DD 23:59:59")],
                    type,
                    tabIndex: 3
                })
            }, 100)
        },
        _audit(row) {
            this.$refs[this.refAudit].open(row)
        },
        _config(row) {
            let params = {
                platform: row.platform,
                name: row.name,
                area: row.serviceName,
                tel: row.tel,
                role: row.role
            }
            this.$refs[this.refConfig].open(params)
        },
        _search() {
            this.listQuery.page = 1
            this.getDataList()
        },
        _close() {
            if (this.showDialogType === 1) {
                this.$refs[this.refMemberMoveData].close()
            } else if (this.showDialogType === 2) {
                this.$refs[this.refMemberBatteryData].close()
            } else if (this.showDialogType === 3) {
                this.$refs[this.refMemberRepairData].close()
            }
            this.showDialog = false
            this.showDialogType = 0
        },
        openExportExcel() {
            if (this.total > this.maxExportCount) {
                this.warningMsg("不允许导出超过2万条数据，如有需要，请联系管理员处理!")
                return false
            }
            let searchs = JSON.parse(JSON.stringify(this.listQuery))
            searchs.page = 1
            searchs.size = this.maxExportCount
            window.$common.fullLoading()
            funEmployees.GetEmployeeDayWorks(searchs).then(res => {
                if (res && res.items && res.items.length > 0) {
                    let tableDatas = res.items.map(x => {
                        x.date = moment(x.date).format("YYYY-MM-DD")
                        x.roleDesc = this.arrEmployeeRole && this.arrEmployeeRole.find(y => y.value === x.role) ? this.arrEmployeeRole.find(y => y.value === x.role).desc : ""
                        // 计算时长
                        x.workTimeDesc = []
                        for (let t in x.workTimePeriods) {
                            let st = `${x.date} ${x.workTimePeriods[t].startTime}`
                            let et = `${x.date} ${x.workTimePeriods[t].endTime}`
                            x.workTimePeriods[t].durationDec = window.$util.converDuration(st, et, "h", true)
                            x.workTimePeriods[t].durationTxt = window.$util.converDuration(st, et, "h") || "0秒"
                            x.workTimeDesc.push(`${x.workTimePeriods[t].name}：${x.workTimePeriods[t].startTime}~${x.workTimePeriods[t].endTime}(${x.workTimePeriods[t].durationTxt})`)
                        }
                        x.workTimeDesc = x.workTimeDesc.join("\n")
                        return x
                    })
                    let exportData = ""
                    if (searchs.startDate && searchs.endDate) {
                        let sbtd = moment(searchs.startDate).format("YYYY-MM-DD")
                        let ebtd = moment(searchs.endDate).format("YYYY-MM-DD")
                        exportData = sbtd == ebtd ? sbtd : `${sbtd}至${ebtd}`
                    } else {
                        exportData = "全部"
                    }
                    let exportName = `${this.$store.getters.serviceArea}的员工工作记录表(${exportData}).xlsx`
                    EmployeeDayWorkLogs(exportName, tableDatas)
                } else {
                    window.$common.closeFullLoading()
                    setTimeout(() => {
                        this.alert("没有需要导出的数据!")
                    }, 10)
                }
            }).catch(() => {
                console.log("export error")
            })
        }
    }
  }
</script>